<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<!-- <v-dialog v-if="errorDialog" v-model="errorDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="close">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
						</div>
						<template v-if="sticker && sticker.stickerType === 'TTS'">
							<img src="@/assets/images/talking-error.png" class="offline-bot" alt="Oops" />
						</template>
						<template v-else>
							<img src="@/assets/images/sensors-offline-bot.png" class="offline-bot" alt="Oops" />
						</template>
					</div>
					<div class="popup-body">
						<div v-if="isBroadcaster" class="popup-content">
							<template v-if="sticker && sticker.stickerType === 'TTS'">
								<h4 class="fs--16 fw--600 text-uppercase popup-heading mt-8">TTS STICKER OFFLINE</h4>
								<p class="fw--600 fs--12 mt-2 white--text">
									Our sensors detect that this TTS Sticker is currently inactive. Please check to make sure you have added the TTS <span class="popup-heading">Browser Media Source URL</span> to your broadcast software.
								</p>
							</template>
							<template v-else>
								<h4 class="fs--16 fw--600 text-uppercase popup-heading mt-8">Browser Source Offline!</h4>
								<p class="fw--600 fs--12 mt-2 white--text">
									Our sensors detect that your browser source is not currently active. Please make sure
									you have added the
									<span class="popup-heading">Browser Media Source URL</span> to your broadcast software.
								</p>
							</template>
							

							<v-btn
								block
								color="primary"
								class="fs--15 fw--600 py-6 mt-4 action-btn"
								@click="goToURL('extension')">
								OPEN EXTENSION <br />
								CONFIGURATION
							</v-btn>
							<v-btn
								block
								color="primary"
								class="fs--15 fw--600 py-6 mt-3 action-btn"
								@click="goToURL('discord')">
								GET SUPPORT ON OUR <br />
								DISCORD SERVER
							</v-btn>
						</div>
						<div v-else class="popup-content">
							<template v-if="sticker && sticker.stickerType === 'TTS'">
								<h4 class="fs--14 fw--600 mt-8 text-uppercase popup-heading">
									TTS STICKER OFFLINE
								</h4>
								<p class="fw--600 fs--13 mt-3 white--text">
									Our sensors detect that this TTS Sticker is currently inactive. Please ask the broadcaster to make sure they have added the TTS
									<span class="popup-heading">Browser Media Source URL</span> to their broadcast software.
								</p>
							</template>
							<template v-else>
								<h4 class="fs--14 fw--600 mt-8 text-uppercase popup-heading">
									This broadcaster is either offline or has not yet activated Stream Stickers!
								</h4>
								<p class="fw--600 fs--13 mt-3 white--text">
									Check back later or ask the broadcaster to confirm they have properly configured their
									<span class="popup-heading">Browser Media Source URL</span> in their broadcasting
									software.
								</p>
							</template>
							
						</div>
					</div>
				</div>
			</div>
		</v-dialog> -->

		<PopupDialog v-if="errorDialog">
			<template #popupHeader>
				<div class="popup-header pa-0 text-center">
					<div class="text-right pa-1">
						<v-btn class="close-icon" small icon @click="close">
							<v-icon size="18">{{ icons.mdiClose }}</v-icon>
						</v-btn>
					</div>
					<template v-if="sticker && sticker.stickerType === 'TTS'">
						<img src="@/assets/images/talking-error.png" class="offline-bot" alt="Oops" />
					</template>
					<template v-else>
						<img src="@/assets/images/sensors-offline-bot.png" class="offline-bot" alt="Oops" />
					</template>
				</div>
			</template>
			<template #popupBody>
				<div class="popup-body">
					<div v-if="isBroadcaster" class="popup-content">
						<template v-if="sticker && sticker.stickerType === 'TTS'">
							<h4 class="fs--16 fw--600 text-uppercase popup-heading mt-8">TTS STICKER OFFLINE</h4>
							<p class="fw--600 fs--12 mt-2 white--text">
								Our sensors detect that this TTS Sticker is currently inactive. Please check to make sure
								you have added the TTS <span class="popup-heading">Browser Media Source URL</span> to your
								broadcast software.
							</p>
						</template>
						<template v-else>
							<h4 class="fs--16 fw--600 text-uppercase popup-heading mt-8">Browser Source Offline!</h4>
							<p class="fw--600 fs--12 mt-2 white--text">
								Our sensors detect that your browser source is not currently active. Please make sure
								you have added the
								<span class="popup-heading">Browser Media Source URL</span> to your broadcast software.
							</p>
						</template>


						<v-btn block color="primary" class="fs--15 fw--600 py-6 mt-4 action-btn"
							@click="goToURL('extension')">
							OPEN EXTENSION <br />
							CONFIGURATION
						</v-btn>
						<v-btn block color="primary" class="fs--15 fw--600 py-6 mt-3 action-btn"
							@click="goToURL('discord')">
							GET SUPPORT ON OUR <br />
							DISCORD SERVER
						</v-btn>
					</div>
					<div v-else class="popup-content">
						<template v-if="sticker && sticker.stickerType === 'TTS'">
							<h4 class="fs--14 fw--600 mt-8 text-uppercase popup-heading">
								TTS STICKER OFFLINE
							</h4>
							<p class="fw--600 fs--13 mt-3 white--text">
								Our sensors detect that this TTS Sticker is currently inactive. Please ask the broadcaster
								to make sure they have added the TTS
								<span class="popup-heading">Browser Media Source URL</span> to their broadcast software.
							</p>
						</template>
						<template v-else>
							<h4 class="fs--14 fw--600 mt-8 text-uppercase popup-heading">
								This broadcaster is either offline or has not yet activated Stream Stickers!
							</h4>
							<p class="fw--600 fs--13 mt-3 white--text">
								Check back later or ask the broadcaster to confirm they have properly configured their
								<span class="popup-heading">Browser Media Source URL</span> in their broadcasting
								software.
							</p>
						</template>
					</div>
				</div>
			</template>
		</PopupDialog>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from '@/store';
import { mdiClose } from '@mdi/js';
import PopupDialog from '@/components/panel/PopupDialog.vue';

export default {
	name: 'ErrorDialog',
	components: {
		PopupDialog
	},
	props: {
		errorDialog: {
			type: Boolean,
			default: false,
		},
		sticker: {
			type: Object,
			default: null,
		},
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const isBroadcaster = computed(() => store.state.role == 'broadcaster');
		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const close = () => {
			ctx.emit('onClose');
		};

		const goToURL = type => {
			if (type === 'extension') {
				window.open(`https://dashboard.streamstickers.com/settings`, '_blank');
			}

			if (type === 'discord') {
				window.open('https://discord.gg/2ePbGrc', '_blank');
			}
		};

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		};

		return {
			isBroadcaster,
			theme,
			size,
			goToURL,
			close,
			cancelEvent,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>

<style scoped>
img.offline-bot {
	margin-top: -30px !important;
}
</style>
